import { deepMerge } from '../utils/deepMerge';
import { landingPagePatches } from './landingPagePatches';
import { permitDepartmentPagePatches } from './permitDepartmentPagePatches';
function clonePage(page) {
    return JSON.parse(JSON.stringify(page));
}
function patchForPageId(pageId, locale) {
    if (locale === 'en')
        return undefined;
    if (pageId === 'landing')
        return landingPagePatches[locale];
    if (pageId === 'permit-department')
        return permitDepartmentPagePatches[locale];
    return undefined;
}
/**
 * Applies locale-specific overrides to a loaded page definition (`landing`, `permit-department`, … + `es`).
 * Keeps a single source JSON in `public/pages/`; translations live in `locale/*PagePatches.ts`.
 */
export function applyPageLocale(page, locale) {
    if (locale === 'en')
        return page;
    const patch = patchForPageId(page.id, locale);
    if (!patch)
        return page;
    const next = clonePage(page);
    if (patch.title)
        next.title = patch.title;
    const sectionMap = patch.sections;
    next.sections = next.sections.map((section) => {
        const key = section.key;
        if (!key || !sectionMap[key])
            return section;
        const props = section.props ?? {};
        return {
            ...section,
            props: deepMerge({ ...props }, sectionMap[key]),
        };
    });
    return next;
}
